module.exports = __webpack_public_path__ + "img/food-3.6e48d7f8.jpg";